import Vue from "vue";
import Vuex from "vuex";
import defaultStore from "./defaultStore";
import auth from "./auth.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        defaultStore
    }
});
